import { Box, IconButton, Tooltip } from '@mui/material';

import FacebookIcon from '@mui/icons-material/Facebook';
import YouTubeIcon from '@mui/icons-material/YouTube';
import React from 'react';
import { Image } from "react-ui-components/components/Tickets/Image";
import { getOptimizedAsset } from "../utils/optimizedImages";

const ICON_SIZE = 20;
const instagramAsset = getOptimizedAsset("src/assets/icons/instagram-icon.png", ICON_SIZE);
const instagramFallback = require("../assets/icons/instagram-icon.png");
const tiktokAsset = getOptimizedAsset("src/assets/icons/tikto-icon.png", ICON_SIZE);
const tiktokFallback = require("../assets/icons/tikto-icon.png");

const renderIcon = (asset: ReturnType<typeof getOptimizedAsset>, fallback: string, alt: string) => (
  <Image
    width={ICON_SIZE}
    height={ICON_SIZE}
    src={asset?.fallback || fallback}
    sources={asset?.sources}
    alt={alt}
    sizes="(max-width: 640px) 18px, 20px"
  />
);

const socialLinks = [
  {
    name: 'YouTube',
    color: 'red',
    icon: <YouTubeIcon />,
    url: 'https://www.youtube.com/@winfacilpremioshow',
  },
  {
    name: 'Facebook',
    color: '#3d66ff',
    icon: <FacebookIcon />,
    url: 'https://www.facebook.com/winfacilrd',
  },
  {
    name: 'Instagram',
    color: 'yellow',
    icon: renderIcon(instagramAsset, instagramFallback, 'instagram'),
    url: 'https://www.instagram.com/winfacilrd/profilecard/?igsh=MTYyOTcxc2lnaGIy',
  },
  {
    name: 'TikTok',
    color: 'black',
    icon: renderIcon(tiktokAsset, tiktokFallback, 'tiktok'),
    url: 'https://www.tiktok.com/@winfacil?_t=ZP-8sGk8VJYTUc&_r=1',
  },
];

const SocialMediaLinks: React.FC = () => {
  return (
    <Box className={'flex justify-center mx-3 py-2'}>
      {socialLinks.map((item) => (
        <Tooltip key={item.name} title={item.name} arrow>
          <IconButton
            className="hover:scale-110 transition-transform"
            sx={{
              color: item.color,
            }}
            color={'primary'}
            component="a"
            href={item.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            {item.icon}
          </IconButton>
        </Tooltip>
      ))}
    </Box>
  );
};

export default SocialMediaLinks;
